<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";

/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";

/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";

// BOOTSTRAP VUE
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
/* Import Bootstrap Vue Styles */

@import "~@riophae/vue-treeselect/dist/vue-treeselect.css";
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

</style>
